import { LATEST_POLICY_UPDATE_ISO } from 'app/config/policyUpdates'

const latestPolicyUpdateDate = new Date(LATEST_POLICY_UPDATE_ISO)

const initialState = () => ({
  needsAcceptance: false
})

export default {
  namespaced: true,

  state: initialState(),

  getters: {
    needsTermsAcceptance(state) {
      return state.needsAcceptance
    }
  },

  mutations: {
    setNeedsAcceptance(state, value) {
      state.needsAcceptance = value
    }
  },

  actions: {
    evaluate({ commit }, { account }) {
      if (!account || account.id == null) {
        commit('setNeedsAcceptance', false)
        return
      }

      const acceptedAt = account.termsAcceptedAt
      const acceptedDate = acceptedAt ? new Date(acceptedAt) : null
      const needsAcceptance = !acceptedDate || acceptedDate < latestPolicyUpdateDate

      commit('setNeedsAcceptance', needsAcceptance)
    }
  }
}
